import {
  PAYMENT_METHODS,
  PAYMENT_PARTNER_IDS,
  BRAND_DOMAIN,
} from "@chef/constants";
import { isEqualStrings } from "@chef/utils/equal";

export const getPaymentMethod = (
  paymentPartnerId: string,
): typeof PAYMENT_METHODS[keyof typeof PAYMENT_METHODS] => {
  return isEqualStrings(paymentPartnerId, PAYMENT_PARTNER_IDS.COLLECTOR)
    ? PAYMENT_METHODS.INVOICE
    : PAYMENT_METHODS.CARD;
};

export const getPaymentGatewayOrigin = () => {
  if (
    process.env.VERCEL_ENV === "preview" &&
    process.env.VERCEL_GIT_COMMIT_REF !== "qa"
  ) {
    const ref = process.env.VERCEL_GIT_COMMIT_REF.toLowerCase().replace(
      /_/g,
      "",
    );
    return `https://pay-cheffelo-com-git-${ref}-cheffelo.vercel.app`;
  }

  if (process.env.VERCEL_GIT_COMMIT_REF === "qa") {
    return `https://pay-qa.${BRAND_DOMAIN}`;
  }

  if (process.env.VERCEL_ENV === "production") {
    return `https://pay.${BRAND_DOMAIN}`;
  }

  if (process.env.VERCEL_ENV === "development") {
    const domain = BRAND_DOMAIN.replace(/\.(no|se|dk)/g, ".localhost");
    return `https://pay.${domain}`;
  }

  return process.env.PAYMENT_GATEWAY_ORIGIN;
};
